/* eslint-disable @typescript-eslint/no-unused-vars */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { of } from 'rxjs/internal/observable/of';
import { GetInvoicesPaginatedResponse, InvoiceDetailResponse } from '../../app/features/wallet/domain/invoices.model';
import { InvoiceDetailMock } from '../dataMocks/invoice-detail-mock';
import { invoicesListResponseMock } from '../dataMocks/invoices-list-response-mock';

@Injectable()
export class InvoicesApiServiceMock {
    listInvoices(
        page: number,
        pageSize: number,
        status: string | null,
        type: string | null,
        includeInvoiceWithoutPayment: boolean
    ): Observable<GetInvoicesPaginatedResponse> {
        return of({ ...invoicesListResponseMock });
    }

    getInvoiceDetail(id: string): Observable<InvoiceDetailResponse> {
        return of({ ...InvoiceDetailMock });
    }

    getInvoiceActivitiesBreakdown(id: string): Observable<Blob> {
        const pdfContent = `%PDF-1.4
1 0 obj
<<
  /Type /Catalog
  /Pages 2 0 R
>>
endobj
2 0 obj
<<
  /Type /Pages
  /Kids [3 0 R]
  /Count 1
>>
endobj
3 0 obj
<<
  /Type /Page
  /Parent 2 0 R
  /Resources <<
    /Font <<
      /F1 4 0 R
    >>
  >>
  /MediaBox [0 0 612 792]
  /Contents 5 0 R
>>
endobj
4 0 obj
<<
  /Type /Font
  /Subtype /Type1
  /BaseFont /Helvetica
>>
endobj
5 0 obj
<<
  /Length 130
>>
stream
BT
  /F1 24 Tf
  100 700 Td
  (Next Pass Miles PDF Example) Tj
  0 -30 Td
  /F1 14 Tf
  (Invoice ID: ${id}) Tj
  0 -30 Td
  (Date: ${new Date().toLocaleDateString()}) Tj
ET
endstream
endobj
xref
0 6
0000000000 65535 f \n0000000009 00000 n \n0000000070 00000 n \n0000000122 00000 n \n0000000252 00000 n \n0000000291 00000 n \ntrailer
<<
  /Size 6
  /Root 1 0 R
>>
startxref
400
%%EOF`;

        const blob = new Blob([pdfContent], { type: 'application/pdf' });
        return of(blob);
    }
}
